import { render, staticRenderFns } from "./ErrorsInTime.vue?vue&type=template&id=0b7da20a&scoped=true&"
import script from "./ErrorsInTime.vue?vue&type=script&lang=js&"
export * from "./ErrorsInTime.vue?vue&type=script&lang=js&"
import style0 from "./ErrorsInTime.vue?vue&type=style&index=0&id=0b7da20a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7da20a",
  null
  
)

export default component.exports